import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import StickyHeader from "@/components/landing/StickyHeader";
import KineticHero from "@/components/landing/KineticHero";
import Categories from "@/components/landing/Categories";
import WhyChooseUs from "@/components/landing/WhyChooseUs";
import HowItWorks from "@/components/landing/HowItWorks";
import Stats from "@/components/landing/Stats";
import Testimonials from "@/components/landing/Testimonials";
import Faq from "@/components/landing/Faq";
import FinalCta from "@/components/landing/FinalCta";
import Footer from "@/components/landing/Footer";
import FloatingCtas from "@/components/landing/FloatingCtas";

export default function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, anchors: { offset: -90 } });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="overflow-x-clip bg-paper font-body text-ink">
      <StickyHeader />
      <main className="pb-14 md:pb-0">
        <KineticHero />
        <Stats />
        <Categories />
        <WhyChooseUs />
        <HowItWorks />
        <Testimonials />
        <Faq />
        <FinalCta />
      </main>
      <Footer />
      <FloatingCtas />
    </div>
  );
}
